import { render, staticRenderFns } from "./PropostaResumo.vue?vue&type=template&id=38380a44"
import script from "./PropostaResumo.vue?vue&type=script&lang=js"
export * from "./PropostaResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports